import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IconButton, PopupMessage } from '..';
import { DeleteIconNew, TrashIconNew, TrashWhiteIconNew, deleteIcon } from '../../../style/images';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';
import { cartDispatcher, combineDispatchers, popupDispatcher } from '../../store';
import { RemoveProductsCart } from '../cart/RemoveProductsCart';
import { Box, Dialog, IconButton as MuiIconButton } from '@mui/material';
import classNames from 'classnames';

export class RemoveButtonComponent extends Component {

  constructor(props){
    super(props);
    this.state={
      show:false,
    }
  }

  deleteFromCart = () => {
    const { product } = this.props;
    this.props.deleteFromCart( (product.isSuperConfiguration && product.additionalProducts[0]) || product );
    this.handleClose();
  }

  openConfirmPopup() {    
    const { product } = this.props;
    this.props.setPopup( 
      {
        title: `Removing ${ product.name }`,
        component: <PopupMessage
          text={ translate( 'Do you really want to remove {item} from the cart?', { item: product.name } ) } 
          actionText={ translate( 'Remove' ) } 
          onClick={ this.deleteFromCart }
        />,
        showHeader: false,
        keepOpen: false 
      } 
    );
  }

  handleClose = ()=>{
    console.log("called")
    this.setState({show:false})
    this.props.closeDialog && this.props.closeDialog()
  }

  removeItem = () => {
    const { fromCart, onClick, product } = this.props;
    // fromCart && this.openConfirmPopup();
    // onClick && onClick( product );
    // this.props.onToggle();
    this.props.setHideItemActions && this.props.setHideItemActions()
    fromCart&&this.setState({show:true});
    onClick && onClick( product );
  }

  render() {
    const { disabled, hidden, text, icon, mobileCart } = this.props;
    const classnames = classNames("delete-button", "round-button")

    return<>
      {!this.props.mobileCartView?<>
      <IconButton 
      tooltip={ translate( 'Delete' ) }
      className={!mobileCart&&classnames} 
      icon={ icon?icon:DeleteIconNew } 
      onClick={ this.removeItem }
      disabled={ disabled }
      hidden={ hidden }
      text={ text }
    />
    </>:<div className="items" onClick={this.removeItem}>
                  <MuiIconButton disableFocusRipple disableRipple disableTouchRipple><Box component="img" src={TrashIconNew} sx={{width:"20px", height:"20px"}}></Box></MuiIconButton>
                  <span style={{color: "var(--secondary-colors-data-vis-red-60, #E12E2E)"}}>{translate("Remove from cart")}</span>
                </div>}
    <Dialog open={this.state.show || this.props.show} onClose={this.handleClose} PaperProps={{sx:{position:"absolute", top:{md:"160px", xs:"296px"}}}}>
      <RemoveProductsCart singleItemRemove text={ translate( 'Do you really want to remove {item} from the cart?', { item: this.props.product.name } ) } 
                            onDelete={this.deleteFromCart}
                            onClose={this.handleClose}></RemoveProductsCart>
    </Dialog>
    </> 
  }
}

RemoveButtonComponent.propTypes = {
  deleteFromCart: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  fromCart: PropTypes.bool,
  hidden: PropTypes.bool,
  onClick: PropTypes.func,
  product: PropTypes.shape( {} ),
  setPopup: PropTypes.func.isRequired
};

export const RemoveButton = connect( null, combineDispatchers( cartDispatcher, popupDispatcher ) )( RemoveButtonComponent );